import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-contact-group-list',
  templateUrl: './contact-group-list.component.html',
  styleUrls: ['./contact-group-list.component.scss']
})
export class ContactGroupListComponent {

 
  contactForm!: FormGroup;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad2 = true;
  // isRefresh = false;
  @Input() isRefresh: any;
  formAction: string = 'Create';

  displayedColumns: string[] = [
    "sno",
    "name",
    "source",
    "email",
    "phone",
    "action"
  ];


  @Input() currentSelectedContactGroupID: any;
  selectedContactId: any;
  @Input() GroupListData: any;
  @Input() currentPage: any;
  @Input() pageSize: any;
  @Input() totalRows: any;
  @Input() dataSource: any;
  @Input() initialLoad: any;
  formSubmitted = false;
@ViewChild('contact_form') contactFormModal!: TemplateRef<any>;
  constructor(
    private toast: ToastrService,
    private api: ContactGrouopService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private fb: FormBuilder
  ) {

  }


  ngAfterViewInit() {
    this.loadData();
    this.initContactForm();
  }

  initContactForm() {
  this.contactForm = this.fb.group({
    id: [null],
    name: ['', Validators.required],
    source: [''],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required]]
  });
}

  deleteContactData() {

    this.btnLoading = true;
    const payload = {
      id: this.selectedContactId.id,
      contact_group_id: this.currentSelectedContactGroupID,
      hospital_id: this.localStorage.getHospitalId()
    };  
    this.api.deleteGroupListContact(payload).subscribe(
      {
        next: (res: any) => {   
          this.toast.success('Group Contact deleted successfully');
          this.btnLoading = false;
          this.modalService.dismissAll();
          this.loadData();
        },
        error: (error: any) => {
          console.error('Error deleting group contact:', error);
          this.toast.error('Failed to delete group contact . Please try again.');
          this.modalService.dismissAll();
          this.btnLoading = false;
        }
      }
    );
  }
  fn_deleteContact(deleteContact: any, element: any) {
    this.selectedContactId = element;
    this.modalService.open(deleteContact, { centered: true });
  } 

  editContact(element: any,model: any) {
    this.selectedContactId = element;
    this.formAction = 'Edit';
    this.contactForm.patchValue({
      id: this.selectedContactId.id,
      name: this.selectedContactId.name,
      source: this.selectedContactId.source,
      email: this.selectedContactId.email,
      phone: this.selectedContactId.phone
    });
    this.modalService.open(model, { centered: true });
  }

  openAddContact() {
  this.modalService.open(this.contactFormModal, { centered: true });  
  this.formAction = 'Add';
  this.contactForm.reset({
    id: null,
    name: '',
    source: '',
    email: '',
    phone: ''
  });
}
saveContact() {
  this.formSubmitted = true;
  console.log("Saving contact...",this.contactForm.invalid);

  if (this.contactForm.invalid) {
    this.contactForm.markAllAsTouched();
    return;
  }

  this.btnLoading = true;
  let payload = this.contactForm.value;
  payload.contact_group_id = this.currentSelectedContactGroupID;
  payload.hospital_id = this.localStorage.getHospitalId();
  payload.source = payload.source || 'manual';
  const rawPhone = this.contactForm.value.phone ?? '';
  const clean = rawPhone.toString().replace('+', '');

  payload = {
    ...this.contactForm.value,
    phone: clean
  };


  if (payload.id) {
    payload.id = payload.id;
    // Update
    this.api.updateContactGroupList(payload).subscribe({
      next: () => {
        this.toast.success('Contact updated successfully');
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.loadData();
        // this.ds.close();
        // this.loadContacts();
      },
      error: () => {
        this.toast.error('Failed to update contact');
        this.btnLoading = false;
      }
    });

  } else {
    delete payload.id;

    let mappedData = [];
    mappedData.push({
      name: payload.name, 
      source: payload.source || 'manual',
      email: payload.email,
      phone: payload.phone
    });

   const finalData = {
      hospital_id: this.localStorage.getHospitalId(),
      contact_group_id: this.currentSelectedContactGroupID,
      contacts: mappedData
    };
  
    // Add
    this.api.addGroupListContact(finalData).subscribe({
      next: () => {
        this.toast.success('Contact added successfully');
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.loadData();
        // this.modalRef.close();
        // this.loadContacts();
      },
      error: () => {
        this.toast.error('Failed to add contact');
        this.btnLoading = false;
      }
    });
  }
}

  loadData(type?: string) {


    try {
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {

    this.isRefresh = true;
            
            console.log("hospital_id", this.localStorage.getHospitalId())
          
            const payload = {
              "where": {
                  "hospital_id": this.localStorage.getHospitalId(),
                  "contact_group_id": this.currentSelectedContactGroupID
              },
              "filter": null,
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                  "col": "\"contact_group_list\".\"createdAt\"",
                  "dir": "DESC"
              }
          }
        

            return this.api
              .getAllContactGroupList(payload)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            this.isRefresh = false;
            return response.rows;
          })
        )
        .subscribe({
          next: (data) => {
          
            this.initialLoad2 = false;

            if(this.initialLoad === true){
              return;
            }
            this.dataSource = new MatTableDataSource<any>(data);

            this.GroupListData = data;

           this.isRefresh = false;
          },
          error: (e) => {
            this.initialLoad = false;
           this.isRefresh = false;

            console.error(e);
          },
          complete: () => {
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  resetPaginator() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10; // Set default pageSize or any value you want
    }
  }

}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}